import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {Sl3AnagrafService} from '../../../general-services/service-sl3-anagraf/sl3-anagraf.service';
import * as toastr from 'toastr';
import {L1Model} from '../../../../models/L1Model';

@Component({
  selector: 'app-edit-l1-anagraf',
  templateUrl: './edit-sl3-anagraf.component.html',
  styleUrls: ['./edit-sl3-anagraf.component.scss']
})
export class EditSl3AnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  l1: L1Model;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  saveSubscribe: Subscription;
  parameterSubscribe: Subscription;

  id: number;
  L1Cod: string;
  l1Json: any;
  description: any;
  submitted: boolean;


  constructor(private route: ActivatedRoute, private router: Router,
              private sl3AnagrafService: Sl3AnagrafService, private _Activatedroute: ActivatedRoute) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.l1Json = params['row'];
      });

    this.l1 = new L1Model();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });

    this.l1 = JSON.parse(this.l1Json) as L1Model;

    this.formValidator.patchValue({
      cod: this.l1 ? this.l1.cod : ''
    });

    this.formValidator.patchValue({
      description: this.l1 ? this.l1.description : ''
    });

    _Activatedroute.params.subscribe(params => {
      this.id = params['id'];
      this.L1Cod = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL3_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.l1.cod = this.formValidator.controls['cod'].value;
      this.l1.description = this.formValidator.controls['description'].value;
      this.saveSubscribe = this.sl3AnagrafService.update(this.sl3AnagrafService.baseUrl, this.l1).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, SL3 Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('SL3 was edited with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL3_ANAGRF]);
          }
        }, error => {
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.formValidator.controls; }

}
